import api from '../resources/privilege-templates.api';
import actionTypes from './action-types';

export const fetchPrivilegeTemplatesRequest = () => ({
  type: actionTypes.FETCH_PRIVILEGE_TEMPLATES_REQUEST,
});

export const fetchPrivilegeTemplatesSuccess = (list) => ({
  type: actionTypes.FETCH_PRIVILEGE_TEMPLATES_SUCCESS,
  list,
});

export const fetchPrivilegeTemplatesFailure = () => ({
  type: actionTypes.FETCH_PRIVILEGE_TEMPLATES_FAILURE,
});

export const fetchPrivilegeTemplates = (userClass, retailerType) => async (dispatch) => {
  try {
    dispatch(fetchPrivilegeTemplatesRequest());

    const list = await api.fetchPrivilegeTemplates(userClass, retailerType);
    dispatch(fetchPrivilegeTemplatesSuccess(list));
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('FETCH_PRIVILEGE_TEMPLATES', error);
    dispatch(fetchPrivilegeTemplatesFailure());
  }
};



// WEBPACK FOOTER //
// ./src/modules/privilege-templates/actions/fetch-privilege-templates.actions.js